<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <h3 class="box-title">
        <i class="fa fa-tag mr-5"></i>
        {{'price_arrangement' | translate}}
      </h3>
      <div class="box-tools pull-right">
        <div class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        </div>
      </div>
    </div>
    <div class="box-body">
      <div class="row">
        <div class="col-md-4 col-sm-12 col-xs-12 border-right">
          <div class="description-block">
            <span class="description-text">{{'exptected_sales' | translate}}:</span>
            <h4 class="no-margin">{{price.expected_amount | currency}}</h4>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12 border-right">
          <div class="description-block">
            <span class="description-text">{{'actual_sales' | translate}}:</span>
            <h4 class="no-margin">{{price.amount | currency}}</h4>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12 ">
          <div class="description-block">
            <span class="description-text">{{'price_margin' | translate}}:</span>
            <h4 class="no-margin">
              {{price.amount_diff | currency}}
              <span :class="['description-percentage', priceMargin >= 0 ? 'text-green' : 'text-danger', 'ml-5']">
                {{priceMargin | currency('%')}}
                <i :class="['fa', priceMargin >= 0 ? 'fa-caret-up' : 'fa-caret-down', 'ml-5']"></i>
              </span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['price', 'priceMargin'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
    price () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/PriceBoxComponent.vue